import Vue from "vue";

// Components
import "@/components";
import "@fortawesome/fontawesome-free/css/all.css";

// Plugins
import { vuetify } from "@/plugins";
import homeAutomation from "@/plugins/homeAutomation";
import { createProvider } from "@/plugins/apollo";

// Application imports
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

Vue.config.productionTip = false;

Vue.use(homeAutomation);

window.vm = new Vue({
	vuetify,
	router,
	store,
	apolloProvider: createProvider(),
	render: h => h(App),
}).$mount("#app");

// One-time initialization of store modules
window.vm.$store.dispatch("initialize");
